// extracted by mini-css-extract-plugin
export default {"p_content":"dc27d40485"};